import { shouldCaptureConsoleEntryForReport } from './debugLogFilter';

export const getStackTrace = () => {
  const stack = new Error().stack;
  if (!stack) {
    return '';
  }

  const frames = stack
    .split('\n')
    .map((frame) => frame.trim())
    .filter(Boolean);

  return frames[3] || frames[2] || frames[1] || frames[0] || '';
};

const createLogger = () => {
  const logWithInfo =
    (type: 'log' | 'warn' | 'error' | 'info' | 'debug') =>
    (...args: any[]) => {
      if (
        type === 'debug' &&
        !import.meta.env.DEV &&
        !shouldCaptureConsoleEntryForReport('debug', args)
      ) {
        return;
      }

      const stackInfo = getStackTrace();
      const timestamp = new Date().toISOString();
      console[type](`[${timestamp}] (${stackInfo})`, ...args);
    };

  return {
    log: logWithInfo('log'),
    warn: logWithInfo('warn'),
    error: logWithInfo('error'),
    info: logWithInfo('info'),
    debug: logWithInfo('debug'),
  };
};

export const logger = createLogger();
